var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3992_546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.49965 0L0 2.71903L4.49965 5.43812L9 2.71903L4.49965 0ZM13.5 0L9 2.71929L13.5 5.43859L18.0001 2.71929L13.5 0ZM0 8.15761L4.49965 10.8767L9 8.15761L4.49965 5.43859L0 8.15761ZM13.5 5.43859L9 8.15788L13.5 10.8771L18 8.15788L13.5 5.43859ZM4.5 11.7889L9.00035 14.508L13.5 11.7889L9.00035 9.06987L4.5 11.7889Z",
    fill: "#0061FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3992_546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14.5385,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.7c0020aaaa31352116b829ef340bdd36.svg";
export { ForwardRef as ReactComponent };